import { get } from '@bigyouth/base'

export class Converter {
  static convert (select, currencyTotal, currencySymbol, price) {
    const currency = select[select.selectedIndex].value

    get('[js-converter-total]').value = price

    if (currency !== '') {
      currencyTotal.value = Currency.convert(price, 'EUR', currency).toFixed(2)
      currencySymbol.innerHTML = select[select.selectedIndex].getAttribute('data-symbol')
    } else {
      currencyTotal.value = '-'
      currencySymbol.innerHTML = '-'
    }
  }
}
